import React from 'react';
import EventPanels from '../EventPanels';
import NewsletterLink from '../NewsletterLink';
import TaglineSection from '../TaglineSection';
import HomepageCarousel from '../HomepageCarousel';
import './HomePage.css';


//garden 1, rec 1, hayloft 2, kitchen 1, kitchen 1, courtyard 1, rec 2, hayloft 7, rec 3, hayloft 6, labs 1.1, labs 1.2, labs 1.3
export default function HomePage() {
  return (
    <div className="homepage">
      <div className="page">
        {/* Hero carousel at top, aligned to rails */}
        <div className="halftone-bg">
          <div className="home-rail">
            <HomepageCarousel />
          </div>
        </div>
        <TaglineSection />

        {/* Constrain EventPanels to the rails */}
        <div className="events-page-layout">
          <EventPanels />
        </div>

        {/* Halftone band with newsletter link */}
        <div className="halftone-bg">
          <NewsletterLink />
        </div>

        {/* Floorplan section with black background */}
        <div className="floorplan-section-home">
          <div className="home-rail">
            <img 
              src={`${process.env.PUBLIC_URL}/images/floorplan.png`}
              alt="Idea Farm Floorplan" 
              className="floorplan-image-home"
            />
          </div>
        </div>

        <div className="empty-panel" />
      </div>
    </div>
  );
}
